module.exports = __webpack_public_path__ + "img/bg-festival.a93fb29c.jpg";